module.exports = __webpack_public_path__ + "static/media/logo-text-dark.dc8603f4.svg";